<template>
  <div>
    <div class="headWrap" ref="headWrap">
      <header class="header">
        <!-- <router-link to="top"> -->
        <div class="headLogo removeClickBg" id="headLogo"></div>
        <!-- </router-link> -->
        <div
          class="navBtn removeClickBg"
          id="navBtn"
          @click="showAside()"
        ></div>
      </header>
    </div>
    <div
      id="asideWrap"
      data-target="box"
      :class="showside ? 'showAside' : ''"
      @click.stop="closeAside"
    >
      <aside id="asideMenu">
        <img
          id="closeAsideImg"
          src="../assets/images/close.png"
          alt
          data-target="box"
        />
        <nav id="nav">
          <ul>
            <li
              class="menuLi removeClickBg"
              :class="$route.name == 'top' ? 'active' : ''"
              @click="jump('top')"
            >
              {{ $t("message.strid1") }}
            </li>
            <li
              class="menuLi removeClickBg"
              :class="$route.name == 'about' ? 'active' : ''"
              @click="jump('about')"
            >
              {{ $t("message.strid2") }}
            </li>
            <a href="https://mpl.mobilelegends.com/" target="_blank">
              <li class="menuLi removeClickBg" @click="closeAside">
                {{ $t("message.strid3") }}
              </li>
            </a>
            <li
              class="menuLi removeClickBg"
              :class="$route.name == 'community' ? 'active' : ''"
              @click="jump('community')"
            >
              {{ $t("message.strid4") }}
            </li>
            <li
              class="menuLi removeClickBg"
              id="choseLanguage"
              data-hash="language"
              @click="showLanguageFn('language')"
              :class="down ? 'active' : ''"
            >
              <span data-lan="language">{{ $t("message.strid5") }}</span>
              <!-- <span id="currentLan">English</span> -->
              <div class="arrow"></div>
              <img v-if="down" src="../assets/images/down.png" id="down" alt />
              <img v-if="!down" src="../assets/images/up.png" id="up" alt />
            </li>
          </ul>
          <ul id="languageBox" v-if="down">
            <li
              class="languageItem"
              :class="$i18n.locale == 'en' ? 'active' : ''"
              @click="choseLanguageFn('en')"
            >
              ENGLISH
            </li>
            <li
              class="languageItem"
              :class="$i18n.locale == 'id' ? 'active' : ''"
              @click="choseLanguageFn('id')"
            >
              Bahasa Indonesia
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list", "down", "lang"],
  data() {
    return {
      showside: false,
      languageList: ["en", "th", "id"],
      languageText: "ENGLISH",
      lan: "",
    };
  },
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
  },
  methods: {
    showAside() {
      this.showside = true;
      this.$emit("show", false);
    },
    jump(name) {
      this.$router.push({ name });
      this.showside = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$emit("show", true);
    },
    closeAside(e) {
      if (e.target.getAttribute("data-target") == "box") {
        this.showside = false;
        this.down = false;
        this.$emit("show", true);
      }
    },
    showLanguageFn() {
      this.down = !this.down;
    },
    choseLanguageFn(name) {
      this.lan = name;
      this.showside = false;
      this.down = !this.down;
      window.localStorage.setItem("GAMElang", this.lan);
      // this.$emit("chose", name);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/header.scss";
</style>